import React from 'react';
import GeneratorBase from './GeneratorBase';

const OutreachEmailGenerator = () => {
  const fields = [
    {
      name: 'companyName',
      label: 'Company Name',
      type: 'text',
      placeholder: 'e.g., TechCorp Solutions',
      required: true
    },
    {
      name: 'clientType',
      label: 'Client Type',
      type: 'select',
      options: [
        { value: 'Startup', label: 'Startup' },
        { value: 'SME', label: 'Small/Medium Enterprise' },
        { value: 'Enterprise', label: 'Large Enterprise' },
        { value: 'Agency', label: 'Marketing Agency' },
        { value: 'E-commerce', label: 'E-commerce Business' }
      ],
      required: true
    },
    {
      name: 'purpose',
      label: 'Purpose',
      type: 'textarea',
      placeholder: 'e.g., Discussing branding opportunities, Partnership proposal, Service introduction',
      rows: 3,
      required: true
    }
  ];

  return (
    <GeneratorBase
      title="Outreach Email Generator"
      description="Generate professional B2B outreach emails with compelling subject lines, personalized content, and B2World Branding email signature."
      fields={fields}
      apiEndpoint="outreach-email"
      saveDraftEndpoint="outreach-email"
    />
  );
};

export default OutreachEmailGenerator;
